module.exports = __webpack_public_path__ + "static/media/tag.61e29cbf.svg";